import { render, staticRenderFns } from "./ImportEstratificationView.vue?vue&type=template&id=80dfc042"
import script from "./ImportEstratificationView.vue?vue&type=script&lang=js"
export * from "./ImportEstratificationView.vue?vue&type=script&lang=js"
import style0 from "./ImportEstratificationView.vue?vue&type=style&index=0&id=80dfc042&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports